import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from '.';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient, private globalService: GlobalService) {}
  getLogin(obj: any): Observable<any> {
    return this.globalService.post('login', obj);
  }
  getRegister(obj: any): Observable<any> {
    return this.globalService.post('register/school', obj);
  }
  getForgetPassword(obj: any, lang: string): Observable<any> {
    return this.globalService.post(`${lang}/user/reset/password`, obj);
  }
  getResetPassword(obj: any, lang: string): Observable<any> {
    return this.globalService.post(`${lang}/user/confirmreset/password `, obj);
  }
  getResendCode(obj: any): Observable<any> {
    return this.globalService.post('user/activation/resend', obj);
  }
  getScoresLogin(token: string): Observable<any> {
    return this.globalService.get(`user/scores?token=${token}`);
  }
  logout(): Observable<any> {
    return this.globalService.get(`logout`);
  }
  loginToken(body: {token: string}, headers: HttpHeaders): Observable<any> {
    return this.globalService.post('login-token', body, headers);
  }
}
